import BaseService from '@peoplenet/vi-components-ui/src/middleware/BaseService';

class SecurityService extends BaseService {
  prefix = '/userinfo';
}

export default new SecurityService();
